<template>
  <transition name="addPhone">
    <div class="modal-mask">
      <van-row justify="center" class="page-wrapper">
        <div class="place-content-center">
          <van-form>
            <info-message class="apply-loader settings-message">
              {{ $t("popup.addPersonaAccountData") }}
            </info-message>
            <itserve-input
                v-model="ls"
                type="text"
                class="apply-loader fl-upper"
                :placeholder="$t('popup.ls')"
                name="name"
            />
            <itserve-input
                v-model="lastPay"
                type="number"
                class="apply-loader fl-upper"
                :placeholder="$t('popup.lastPay')"
                name="name"
            />
          </van-form>
          <itserve-button
              type="primary"
              class="itserve-round-btn itserve-button-wide mb-25 apply-loader"
              :value="$t('buttons.saveChanges')"
              @click="addPersonalAccountData"
          ></itserve-button>
          <itserve-button
              type="primary"
              class="itserve-round-btn itserve-button-wide mb-25 apply-loader"
              :value="$t('popup.close')"
              @click="confirm"
          ></itserve-button>
        </div>
        <simple-dialog
            v-model="showDialog2"
            :success="actionSuccessfully"
            :title="dialogMessage"
            @change="confirm"
        />
        <simple-dialog
            v-model="showDialog3"
            :success="actionSuccessfully"
            :title="dialogMessage"
        />
      </van-row>
    </div>
  </transition>
</template>
<script>
import InfoMessage from "@/components/content/InfoMessage";
import ItserveInput from "@/components/forms/ItserveInput";
import ItserveButton from "@/components/forms/ItserveButton";
import SimpleDialog from "@/components/content/SimpleDialog";
export default {
  name: "addPersonalAccountData",
  components: {
    ItserveButton,
    ItserveInput,
    InfoMessage,
    SimpleDialog

  },
  data() {
    return {
      showDialog: false,
      showDialog2: false,
      showDialog3: false,
      dialogMessage: "",
      actionSuccessfully: false,
    };
  },
  computed: {
    ls: {
      get() {
        return this.$store.state.PersonalAccount.ls;
      },
      set(ls) {
        this.$store.commit("PersonalAccount/SET_LS", ls);
      },
    },
    lastPay: {
      get() {
        return this.$store.state.PersonalAccount.lastPay;
      },
      set(value) {
        const cleanedValue = value.toString().replace(",", ".").replace(/[^\d.]/g, "");
        const numericValue = cleanedValue === "" ? "" : parseFloat(cleanedValue);
        this.$store.commit("PersonalAccount/SET_LAST_PAY", numericValue);
      },
    },

  },
  methods: {
    addPersonalAccountData() {
      const ls = this.$store.state.PersonalAccount.ls;
      const lastPay = this.$store.state.PersonalAccount.lastPay;

      if (!ls || !lastPay) {
        this.showDialog3 = true;
        this.dialogMessage = this.$t("popup.fieldIsRequired");
      } else {
        this.$store.dispatch("PersonalAccount/setPersonalAccountData");
        this.showDialog2 = true;
        this.dialogMessage = this.$t("popup.save");
      }
    },
    confirm() {
      console.log("CHLENIX CONFIRM")
      this.$emit("closePopup");
    },
  }
}
</script>

<style scoped>
.modal-mask {
  padding-top: 20%;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.app-theme-light .page-wrapper {
  background-color: white !important;
}

</style>